import { render, staticRenderFns } from "./ActualizarServicios.vue?vue&type=template&id=5c7fdb39"
import script from "./ActualizarServicios.vue?vue&type=script&lang=js"
export * from "./ActualizarServicios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports